import React from 'react'
import classNames from 'classnames'
import Column from './GetInvolvedColumn'
import {Tabs, Tab} from 'material-ui/Tabs'
import TabLabel from './TabLabel'
import getInvolvedConfig from '../../configs/get-involved-config'

const GetInvolvedTabs = ({
  handleRoleChange,
  handleTabChange,
  tabIndex 
}) => {

  const curriculumJobs = getInvolvedConfig.filter((job) => {
    return job.type === 'Curriculum'
  })
  const workshopJobs = getInvolvedConfig.filter((job) => {
    return job.type === 'Workshop'
  })

  return (
    <div>
      <Tabs
        className="get-involved-tabber"
        data-route="Curriculum"
        inkBarStyle={{ backgroundColor: '#aa82ff', marginTop: '.25em'}}
        onChange={handleTabChange}
        tabItemContainerStyle={{ backgroundColor: 'white' }}
        value={tabIndex}
      >
        <Tab
          className={classNames({'get-involved-tabs': true, active: tabIndex===0})}
          label={<TabLabel
                  active={tabIndex === 0}
                  label="Curriculum Team"
                  subLabel="Great for creatives & technical types worldwide."/>
                }
          value={0}>
          <Column clickHandler={handleRoleChange} config={curriculumJobs} style={{height: '100%'}} />
        </Tab>
        <Tab 
          className={classNames({'get-involved-tabs': true, active: tabIndex===1})}
          label={<TabLabel
                  active={tabIndex === 1}
                  label="Workshop Team"
                  subLabel="Makers & movers in the LA area and abroad."/>
                }
          value={1}>
          <Column clickHandler={handleRoleChange} config={workshopJobs} style={{height: '100%'}} />
        </Tab>
      </Tabs>
    </div>
  )
}

export default GetInvolvedTabs



// WEBPACK FOOTER //
// ./src/components/GetInvolved/GetInvolvedTabs.js